
const taf = {
  
}

const requestAniFrame = (() => {
    return window.requestAnimationFrame ||
        // Older versions Chrome/Webkit
        window.webkitRequestAnimationFrame ||
        // Firefox < 23
        window.mozRequestAnimationFrame ||
        // opera
        window.oRequestAnimationFrame ||
        // ie
        window.msRequestAnimationFrame || ((callback) => window.setTimeout(callback, 1000 / 60));
})();

const cancelAnimation = (() => {
    return window.cancelAnimationFrame || 
    window.mozCancelAnimationFrame || 
    window.cancelRequestAnimationFrame || 
    ((id) => clearTimeout(id))
})()

module.exports = cb => {
  // return setTimeout(cb, 1000 / 60)
  return requestAniFrame(cb)
}

module.exports.cancel = handle => {
  // return clearTimeout(handle)
  return cancelAnimation(handle)
}
